const TokenLogger = () => null;

export default TokenLogger;
